import React, { Suspense, lazy, useEffect, useState } from 'react';
import './TraumgartenShell.css';

// Eigener Chunk: der Planer wird nach dem ersten Rendern im Leerlauf nachgeladen.
const load = () => import('./Traumgarten');
const Traumgarten = lazy(load);

const idle = (cb) =>
  typeof window.requestIdleCallback === 'function'
    ? window.requestIdleCallback(cb, { timeout: 1500 })
    : window.setTimeout(cb, 600);

function Placeholder() {
  return (
    <div className="tg-shell-placeholder" aria-busy="true">
      <span className="tg-shell-eyebrow">Traumgarten-Planer</span>
      <p className="tg-shell-title">Entwerfen Sie Ihren <em>Traumgarten</em></p>
    </div>
  );
}

export default function TraumgartenSection() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    idle(() => load().then(() => !cancelled && setReady(true)).catch(() => {}));
    return () => { cancelled = true; };
  }, []);

  return (
    <section id="traumgarten" className="tg-shell" aria-label="Traumgarten-Planer">
      {ready ? (
        <Suspense fallback={<Placeholder />}>
          <Traumgarten />
        </Suspense>
      ) : (
        <Placeholder />
      )}
    </section>
  );
}
